import { render, staticRenderFns } from "./LottoResultByDate.vue?vue&type=template&id=187f2502&scoped=true"
import script from "./LottoResultByDate.vue?vue&type=script&lang=js"
export * from "./LottoResultByDate.vue?vue&type=script&lang=js"
import style0 from "./LottoResultByDate.vue?vue&type=style&index=0&id=187f2502&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f2502",
  null
  
)

export default component.exports